import axios from '../configV2.js';
const resource = '/pms';

export default {
//   get(caseNumber='', memberIdNumber='') {
//     console.log({ caseNumber, memberIdNumber });
//     axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
//     const params = new URLSearchParams();
//     if (caseNumber)  params.append('first_name', caseNumber);
//     if (memberIdNumber) params.append('last_name', memberIdNumber);
//     return axios.get(resource, { params: params });
//   },
  getCases(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.post(`${resource}/case/patient`, payload);
  },
  findCase(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.post(`${resource}/case`, payload);
  },
  getPatientInformation(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.post(`${resource}/patient/information`, payload);
  }
};